import { useState as a, useEffect as i } from "react";
import e from "../../utils/load-script.mjs";
const r = () => {
  const t = typeof window < "u" && !!window.paypal, [o, p] = a(!t);
  return i(() => {
    t || e(
      "https://www.paypalobjects.com/api/checkout.min.js",
      "paypal-js",
      () => p(!1)
    );
  }, [t]), {
    isScriptLoading: o
  };
};
export {
  r as useLoadPaypalScript
};
